import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { SharedVehicleGroupAdminModel } from './sharedvehiclegroupadmin.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class SharedVehicleGroupAdminService {

	constructor(private authService: AuthService, private http: Http) { }

	public GetSharedVehicleGroupAdminList(sharedVehicleGroupHashId: string, input?: DataListModel): Observable<IAPIResponse> {
		let getSharedVehicleGroupAdminUrl = WeGoConfig.API_GET_SHAREDVEHICLEGROUPADMIN_DETAIL;
		let queryString = this.authService.HandleAPIListInput(input);
		if (queryString) {
			getSharedVehicleGroupAdminUrl = getSharedVehicleGroupAdminUrl + "?" + queryString + "&sharedVehicleGroupHashID=" + sharedVehicleGroupHashId;
		}
		else {
			getSharedVehicleGroupAdminUrl = getSharedVehicleGroupAdminUrl + "?sharedVehicleGroupHashID=" + sharedVehicleGroupHashId;
		}
		let headers = this.authService.GetHeader();
		let options = new RequestOptions({ headers: headers });
		return this.http.get(getSharedVehicleGroupAdminUrl, options)
			.map(this.authService.HandleAPIResponse)
			.catch(this.authService.HandleAPIError);
	}

	public ExportSharedVehicleGroupAdminList(sharedVehicleGroupHashId: string, input?: DataListModel): any {

		input.currentPage = 0;
		let queryString = this.authService.HandleAPIListInput(input);
		let getShareVehicleGroupAdminUrl = WeGoConfig.API_EXPORT_SHAREDVEHICLEGROUPADMIN_LIST + "?" + queryString + "&sharedVehicleGroupHashID=" + sharedVehicleGroupHashId;;
		let headers = this.authService.GetHeader('text/csv');
		let options = new RequestOptions({ headers: headers });
		return this.http.get(getShareVehicleGroupAdminUrl, options);
	}

	public GetPersonListBySharedVehicleGroupId(sharedVehicleGroupHashId: string, input?: DataListModel): Observable<IAPIResponse> {
		let getPersonUrl = WeGoConfig.API_GET_PERSON_LIST_BY_SHAREDVEHICLEGROUP_ID;
		let queryString = this.authService.HandleAPIListInput(input);
		if (queryString) {
			getPersonUrl = getPersonUrl + "?" + queryString + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
		}
		else {
			getPersonUrl = getPersonUrl + "?sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
		}
		let headers = this.authService.GetHeader();
		let options = new RequestOptions({ headers: headers });
		return this.http.get(getPersonUrl, options)
			.map(this.authService.HandleAPIResponse)
			.catch(this.authService.HandleAPIError);
	}

	public DeleteSharedVehilceGroupAdmin(selectedsharedVehicleGroupAdminHashId: string[]): Observable<IAPIResponse> {
		let headers = this.authService.GetHeader();
		let options = new RequestOptions({ headers: headers });

		return this.http.post(WeGoConfig.API_POST_DELETE_SHAREDVEHICLEGROUP_ADMIN, selectedsharedVehicleGroupAdminHashId, options)
			.map(this.authService.HandleAPIResponse)
			.catch(this.authService.HandleAPIError);
	}

	public AddNewSharedVehicleGroupAdmin(sharedVehicleGroupAdminModel: SharedVehicleGroupAdminModel): Observable<IAPIResponse> {
		let body = sharedVehicleGroupAdminModel;
		let headers = this.authService.GetHeader();
		let options = new RequestOptions({ headers: headers });

		return this.http.post(WeGoConfig.API_POST_SHAREDVEHICLEGROUP_ADMIN_DETAIL, body, options)
			.map(this.authService.HandleAPIResponse)
			.catch(this.authService.HandleAPIError);
	}


	public InActiveSharedVehicleGroupAdmin(svgAdminHashId: string) {
		let getInactiveCompanyAdminUrl = WeGoConfig.API_GET_INACTIVE_SHAREDVEHICLEGROUP_ADMIN + "?sharedVehicleGroupAdminHashId=" + svgAdminHashId;
		let headers = this.authService.GetHeader();
		let options = new RequestOptions({ headers: headers });
		return this.http.get(getInactiveCompanyAdminUrl, options)
			.map(this.authService.HandleAPIResponse)
			.catch(this.authService.HandleAPIError);
	}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroupadmin/models/sharedvehiclegroupadmin.service.ts